// React & Core, Third-Party Libraries
import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import { connect } from "react-redux";
import { withRouter, useHistory } from "react-router-dom";
import InfiniteScroll from "react-infinite-scroll-component";

// Constants & Assets
import {
  ROUTES,
  PAGINATION,
  customerConstants,
  eventBookingParams,
  eventBookingConstants,
  EMPTY_STRING,
} from "../../../../../constants";
import { Images } from "../../../../../assets/images";
// Shared / Reusable Components, Utilities
import { ClearExtendOrTipStorage } from "../../../../../shared/utility";
import GenericTabs from "../../../../../shared/components/Tabs/GenericTabs";
import EventActionCard from "../../../../../shared/components/Events/EventActionCard";
import EventAccordion from "../../../../../shared/components/Accordion/EventAccordion";
import { customerDashboardActions } from "../../../../../redux/actions";
import ConfirmationModal from "../../../../../shared/components/Modal/ConfirmationModal";
import { NavigateToPath } from "../../../../../system";
import { eventBookingActions } from "../../../../../redux/actions/eventBooking.actions";

// Local Components
import EventDetail from "./EventDetail";
import { Redirect } from "react-router-dom/cjs/react-router-dom.min";

const eventTabs = [
  {
    label: "Upcoming",
    value: customerConstants.UPCOMING_EVENTS,
    className: "text",
  },
  {
    label: "Completed",
    value: customerConstants.COMPLETED_EVENTS,
    className: "text",
  },
  {
    label: "Cancelled",
    value: customerConstants.CANCELLED_EVENTS,
    className: "text",
  },
];

const { TABS } = eventBookingConstants;

const MyEventsTab = (props) => {
  /* eslint-disable */
  const [...myEvents] = props.myEvents;

  const history = useHistory();

  const [modal, setModal] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [expandedAccordions, setExpandedAccordions] = useState({});
  const [pageNumber, setPageNumber] = useState(PAGINATION.PAGE_NUMBER);
  const [expandedSubAccordion, setExpandedSubAccordion] = useState(null);
  const [activeTab, setActiveTab] = useState(customerConstants.UPCOMING_EVENTS);
  const [dataToSend, setDataToSend] = useState({
    eventGroupId: null,
    eventId: null,
    userId: 0,
  });

  const [editEventPath, setEditEventPath] = useState(EMPTY_STRING);
  const [showEditEventModal, setShowEditEventModal] = useState(false);

  useEffect(() => {
    props.resetMyEvents();
    setPageNumber(1);
    setHasMore(true);
    fetchEvents(1);
    // eslint-disable-next-line
  }, [activeTab]);

  const fetchEvents = async (_pageNumber) => {
    await props.getMyEvents(
      props.userId,
      activeTab,
      _pageNumber,
      PAGINATION.PAGE_SIZE
    ); // assume page size 5
  };

  useEffect(() => {
    if (props?.myEvents && props?.myEvents.length > 0) {
      let eventslength = props?.myEvents.length;
      let totalGroupCount = props?.myEvents[0].groupCount;
      setHasMore(totalGroupCount > eventslength);
      setPageNumber(Math.ceil(eventslength / PAGINATION.PAGE_SIZE) + 1);
    } else {
      setHasMore(false);
    }
    // eslint-disable-next-line
  }, [props.myEvents]);

  const handleEvents = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  const addReel = (id, orderId) => {
    ClearExtendOrTipStorage();
    localStorage.setItem("activeTab", TABS.ADD_REEL);
    localStorage.setItem("isOnlyReel", true);
    localStorage.setItem("reelEventId", id);
    localStorage.setItem("reelOrderId", orderId);
    localStorage.setItem(customerConstants.NOT_NEW_EVENT, JSON.stringify(true));
    history.push(`/event_booking/`);
  };

  const handleEventCancelation = (eventGroupId, eventId) => {
    if (!modal) {
      const _eventId = eventId ?? null;
      setDataToSend({ eventGroupId, eventId: _eventId, userId: props.userId });
      setModal(true);
    } else {
      props.cancelEvent(
        dataToSend,
        activeTab,
        PAGINATION.PAGE_NUMBER,
        PAGINATION.PAGE_SIZE
      );
      setModal(false);
    }
  };

  const handleAccordionChange = (index) => (event, isExpanded) => {
    setExpandedAccordions((prev) => ({
      ...prev,
      [index]: isExpanded,
    }));
  };

  const handleSubAccordionChange = (panelId) => (event, isExpanded) => {
    setExpandedSubAccordion(isExpanded ? panelId : null);
  };

  const closeAllAccordions = () => {
    setExpandedAccordions({});
  };

  const closeAllSubAccordions = () => setExpandedSubAccordion(null);

  const handleTabChange = (tabValue) => {
    setActiveTab(tabValue);
    handleEvents(tabValue);
    closeAllAccordions();
    closeAllSubAccordions();
  };

  const handleAllEventEdit = (event, pathToGo) => {
    setEditEventPath(pathToGo);
    setShowEditEventModal(true);
  };

  const addUpdateRecapHandler = (path) => {
    props.resetEventBooking();
    NavigateToPath(history, path);
  };

  return (
    <>
      <GenericTabs
        tabs={eventTabs}
        activeTab={activeTab}
        onTabChange={handleTabChange}
      />

      <div className="px-2">
        <InfiniteScroll
          dataLength={myEvents.length}
          next={() => fetchEvents(pageNumber)}
          hasMore={hasMore}
          loader={
            hasMore ? (
              <p className="text-center">loading more events...</p>
            ) : (
              <></>
            )
          }
        >
          {myEvents?.length ? (
            myEvents?.map((event, index) => (
              <EventAccordion
                showEventDate
                key={event.eventGroupId}
                isGroup={event.isGroup}
                event={event}
                classes="mui-event-accordion"
                expanded={expandedAccordions[index] || false}
                onChange={handleAccordionChange(index)}
                eventTitle={event.isGroup ? event.eventGroupName : null}
              >
                {event?.subEvents?.length > 1 ? (
                  <React.Fragment>
                    <div className="d-flex flex-wrap">
                      <EventActionCard
                        to={`/CustomerDashboardTab/MyEvents/${event.eventGroupId}/${customerConstants.DOWNLOAD_INVOICE}`}
                        iconSrc={Images.Invoice}
                        iconAlt="invoice-icon"
                        title="invoice"
                        description="access your event invoice and billing information."
                      />
                      {activeTab === customerConstants.UPCOMING_EVENTS &&
                        event?.isEditAllEventAllowed && (
                          <EventActionCard
                            iconSrc={Images.EditEvent}
                            iconAlt="edit-event-icon"
                            title="edit all events"
                            description="edit booking details for your all upcoming events"
                            onClick={() => {
                              handleAllEventEdit(
                                event,
                                `${ROUTES.EVENT_BOOKING}/${eventBookingParams.EDIT_EVENT}/${event.eventGroupId}`
                              );
                            }}
                          />
                        )}
                      {(activeTab === customerConstants.UPCOMING_EVENTS ||
                        activeTab === customerConstants.COMPLETED_EVENTS) && (
                        <EventActionCard
                          //to={`${ROUTES.EVENT_BOOKING}/${eventBookingParams.ADD_UPDATE_RECAP}/${event.eventGroupId}`}
                          iconSrc={Images.Reel}
                          iconAlt="add-update-reels-event-icon"
                          title="add / update recaps"
                          description="add or update recaps for your all events"
                          onClick={() => {
                            addUpdateRecapHandler(
                              `${ROUTES.EVENT_BOOKING}/${eventBookingParams.ADD_UPDATE_RECAP}/${event.eventGroupId}`
                            );
                          }}
                        />
                      )}
                      {event?.isCombinedEventsReel && (
                        <EventActionCard
                          to={`${ROUTES.CUSTOMER_DASHBOARD_TAB}${ROUTES.GROUP_EVENTS}/${event.eventGroupId}/${customerConstants.ACCESS_GROUP_GALLERY}`}
                          iconSrc={Images.Gallery}
                          iconAlt="Gallery Icon"
                          title="combined recap(z)"
                          description="watch your highlight edit(s) featuring moments from all events here. to view individual event galleries, click into the events below."
                        />
                      )}
                      <EventActionCard
                        iconSrc={Images.CancelEvent}
                        iconAlt="Cancel Event Icon"
                        disabledIcon={Images.CancelEventDisabled}
                        disabledAlt="Cancel Event Disabled Icon"
                        isDisabled={
                          activeTab !== customerConstants.UPCOMING_EVENTS ||
                          !event.isCancelAllEventAllowed
                        }
                        onClick={() => {
                          handleEventCancelation(event?.eventGroupId);
                        }}
                        title="cancel all events"
                        description="cancel your events."
                      />
                    </div>
                    <div className="accordion-title py-2">events:</div>
                    {event.subEvents.map((subEvent, subIndex) => (
                      <EventAccordion
                        showEventDate
                        isGroup={false}
                        key={subIndex}
                        event={subEvent}
                        showExpandedIcon
                        classes="mui-event-accordion mui-sub-event-accordion"
                        summaryLeadingChildren={<span>{subIndex + 1}.</span>}
                        expanded={expandedSubAccordion === subEvent.id}
                        onChange={handleSubAccordionChange(subEvent.id)}
                      >
                        <EventDetail
                          isGroupEvent
                          event={subEvent}
                          eventGroupId={event.eventGroupId}
                          addReel={addReel}
                          activeTab={activeTab}
                          handleEventCancelation={handleEventCancelation}
                          customerDashboardCart={props.customerDashboardCart}
                          remainingUpcomingEvent={event.subEvents.length}
                          setEditEventPath={setEditEventPath}
                          setShowEditEventModal={setShowEditEventModal}
                          addUpdateRecapHandler={addUpdateRecapHandler}
                        />
                      </EventAccordion>
                    ))}
                  </React.Fragment>
                ) : (
                  <EventDetail
                    event={event?.subEvents[0]}
                    eventGroupId={event.eventGroupId}
                    addReel={addReel}
                    activeTab={activeTab}
                    handleEventCancelation={handleEventCancelation}
                    customerDashboardCart={props.customerDashboardCart}
                    setEditEventPath={setEditEventPath}
                    setShowEditEventModal={setShowEditEventModal}
                    addUpdateRecapHandler={addUpdateRecapHandler}
                  />
                )}
              </EventAccordion>
            ))
          ) : (
            <p className="d-flex justify-content-center">no events found</p>
          )}
        </InfiniteScroll>
      </div>

      <ConfirmationModal
        open={showEditEventModal}
        onClose={() => setShowEditEventModal(false)}
        onConfirm={() => {
          setShowEditEventModal(false);
          props.resetEventBooking();
          NavigateToPath(history, `${editEventPath}`);
        }}
        dialogText="confirm_edit_event"
        maxWidth="xs"
        buttonText={"proceed"}
      />

      <Modal
        isOpen={modal}
        contentLabel="Cancel Event Modal"
        className="cancel-event-modal modal-border-colors"
      >
        <div className="modal-content pt-2">
          <p className="text-center p-2">
            please confirm if you wish to proceed with canceling your event.
          </p>
          <div className="con">
            <div class="set-save-btn">
              <button
                type="submit"
                class="custom-btn"
                onClick={() => {
                  handleEventCancelation();
                }}
              >
                confirm
              </button>
            </div>
            <button className="modal-close" onClick={() => setModal(false)}>
              <img
                src="/images/simpleCrossWhite.svg"
                alt="crossIcon"
                className="modal-close-img"
              />
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
};

// Mapping the component's props to the reducer's state
const mapStateToProps = (state) => ({
  userId: state.authentication.userId,
  myEvents: state.customerDashboard.myEvents,
  customerDashboardCart: state.customerDashboard.customerDashboardCart,
});

// Mapping the component's props to the related actions
const mapDispatchToProps = (dispatch) => ({
  resetMyEvents: () => dispatch(customerDashboardActions.resetMyEvents()),
  getMyEvents: (id, status, pageNumber, pageSize) =>
    dispatch(
      customerDashboardActions.myEvents(id, status, pageNumber, pageSize)
    ),
  cancelEvent: (dataObj, status, pageNumber, pageSize) =>
    dispatch(
      customerDashboardActions.cancelEvent(
        dataObj,
        status,
        pageNumber,
        pageSize
      )
    ),
  resetEventBooking: () => dispatch(eventBookingActions.resetEventBooking()),
});

// mapping action and store the function via props
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(MyEventsTab));
